import { ProductPlatformFeatures } from '../providers/resources'
import { doAdminQueries } from '../providers/mutations'
import { atomFamily } from 'jotai/utils'
import { atom } from 'infrastructure/state/jotai.wrapper'
import { Single } from 'infrastructure/api'

async function fetchProductPlatformFeatures(productId: number) {
  return doAdminQueries<Single.ProductPlatformFeatureResponse>([
    {
      resourceData: ProductPlatformFeatures,
      params: {
        product_id: productId,
      },
    },
  ])
}

export const productPlatformFeaturesAtomFamily = atomFamily(
  (productId: number) =>
    atom(async () => {
      const features = await fetchProductPlatformFeatures(productId)
      return features.data.productPlatformFeatures
    }),
)
